import { Box } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import ThspianIconLogo from '../ThspianLogo/ThspianIconLogo';

interface ILoadingProps {
    disableBG?: boolean;
}
const MainLoading: React.FC<ILoadingProps> = ({ disableBG = false }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Box
            sx={{
                display: 'flex',
                ...(!disableBG && { backgroundColor: theme[themeStyle].secondaryBg }),
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 99999,
                position: 'fixed',
                inset: 0,
                width: '100vw',
                minHeight: '100vh',
                height: '100dvh',
            }}>
            <ThspianIconLogo height={'50px'} width={'50px'} fill={theme[themeStyle].logo_color} />
        </Box>
    );
};

export { MainLoading };
